"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserialize = exports.toggleMark = exports.toggleBlock = exports.isMarkActive = exports.isBlockActive = void 0;
var slate_hyperscript_1 = require("slate-hyperscript");
var slate_1 = require("slate");
var LIST_TYPES = ['numbered-list', 'bulleted-list'];
var isBlockActive = function (editor, format) {
    var _a = __read(slate_1.Editor.nodes(editor, {
        match: function (n) { return n.type === format; },
    }), 1), match = _a[0];
    return !!match;
};
exports.isBlockActive = isBlockActive;
var isMarkActive = function (editor, format) {
    var marks = slate_1.Editor.marks(editor);
    return marks ? marks[format] === true : false;
};
exports.isMarkActive = isMarkActive;
var toggleBlock = function (editor, format) {
    var isActive = exports.isBlockActive(editor, format);
    var isList = LIST_TYPES.includes(format);
    slate_1.Transforms.unwrapNodes(editor, {
        match: function (n) { return LIST_TYPES.includes(n.type); },
        split: true,
    });
    var type = format;
    if (isActive) {
        type = 'paragraph';
    }
    else if (isList) {
        type = 'list-item';
    }
    slate_1.Transforms.setNodes(editor, {
        type: type,
    });
    if (!isActive && isList) {
        var block = { type: format, children: [] };
        slate_1.Transforms.wrapNodes(editor, block);
    }
};
exports.toggleBlock = toggleBlock;
var toggleMark = function (editor, format) {
    var isActive = exports.isMarkActive(editor, format);
    if (isActive) {
        slate_1.Editor.removeMark(editor, format);
    }
    else {
        slate_1.Editor.addMark(editor, format, true);
    }
};
exports.toggleMark = toggleMark;
var getElement = function (name) {
    switch (name) {
        case 'BLOCKQUOTE':
            return function () { return ({ type: 'block-quote' }); };
        case 'H1':
            return function () { return ({ type: 'heading-one' }); };
        case 'H2':
            return function () { return ({ type: 'heading-two' }); };
        case 'IMG':
            return function (el) { return ({
                type: 'image-linked',
                url: el.getAttribute('src') || '',
                children: [{ text: el.getAttribute('src') || '' }],
            }); };
        case 'LI':
            return function () { return ({ type: 'list-item' }); };
        case 'OL':
            return function () { return ({ type: 'numbered-list' }); };
        case 'P':
            return function () { return ({ type: 'paragraph' }); };
        case 'PRE':
            return function () { return ({ type: 'code' }); };
        case 'UL':
            return function () { return ({ type: 'bulleted-list' }); };
        default:
            return null;
    }
};
var getTag = function (nodeName) {
    switch (nodeName) {
        case 'CODE':
            return function () { return ({ code: true }); };
        case 'DEL':
            return function () { return ({ strikethrough: true }); };
        case 'EM':
            return function () { return ({ italic: true }); };
        case 'I':
            return function () { return ({ italic: true }); };
        case 'S':
            return function () { return ({ strikethrough: true }); };
        case 'STRONG':
            return function () { return ({ bold: true }); };
        case 'B':
            return function () { return ({ bold: true }); };
        case 'U':
            return function () { return ({ underline: true }); };
        default:
            return null;
    }
};
var deserialize = function (el) {
    console.log(el);
    if (el.nodeType === 3) {
        return el.textContent;
    }
    if (el.nodeType !== 1) {
        return null;
    }
    if (el.nodeName === 'BR') {
        return '\n';
    }
    var nodeName = el.nodeName;
    var parent = el;
    var children = Array.from(parent.childNodes)
        .map(exports.deserialize)
        .flat();
    if (el.nodeName === 'BODY') {
        return slate_hyperscript_1.jsx('fragment', {}, children);
    }
    var matchedElement = getElement(nodeName);
    if (matchedElement) {
        var attrs = matchedElement(el);
        return slate_hyperscript_1.jsx('element', attrs, children);
    }
    var matchedTag = getTag(nodeName);
    if (matchedTag) {
        var attrs_1 = matchedTag(el);
        return children.map(function (child) { return slate_hyperscript_1.jsx('text', attrs_1, child); });
    }
    return children;
};
exports.deserialize = deserialize;
//# sourceMappingURL=helpers.js.map